import React from 'react';

const Footer = () => {
  return (
    <footer>
      <div className="container footer-content">
        <div className="footer-col">
          <h3>CompileX</h3>
          <p>Engineering intelligent software across games, AI, and deep technology.</p>
        </div>
        <div className="footer-col">
          <h4>Links</h4>
          <a href="#home">Home</a>
          <a href="#services">Services</a>
          <a href="#about">About</a>
          <a href="#portfolio">Portfolio</a>
          <a href="#careers">Careers</a>
          <a href="#contact">Contact</a>
        </div>
        <div className="footer-col">
          <h4>Contact</h4>
          <a href="mailto:contact@compilex.com">contact@compilex.com</a>
          <div className="socials">
            <a href="#" aria-label="LinkedIn"><i className="fab fa-linkedin"></i></a>
            <a href="#" aria-label="GitHub"><i className="fab fa-github"></i></a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; CompileX. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
